<template>
  <div>
    <div class="flex lg:flex-row lg:justify-between flex-col gap-2">
      <div class="flex gap-2 text-primary items-center justify-between">
        <div class="flex gap-2 text-primary items-center">
          <v-icon
            color="primary"
            :size="20">
            mdi-human-capacity-decrease
          </v-icon>
          <span class="text-xl font-medium">{{ $t('agent.header') }}</span>
        </div>
        <div class="flex justify-end">
          <tier-create
            v-if="tab === 'manage' && !selected"
            @submit="tierRefetch()" />
        </div>
      </div>
      <div
        v-if="tab === 'agent'"
        class="flex gap-2 flex-col sm:flex-row lg:flex justify-between lg:justify-end overflow-auto">
        <agent-remove-list />
        <agent-create
          @submit="resellerRefetch()" />
      </div>
    </div>
    <v-tabs
      v-model="tab"
      class="app-tab mt-6"
      show-arrows
      @change="deselect()">
      <v-tab
        v-for="header in tabHeaders"
        :key="header.id"
        :href="`#${header.value}`">
        {{ header.title }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        value="manage">
        <v-card flat>
          <v-card-text>
            <template v-if="!selected">
              <title-label
                v-if="this.$vuetify.breakpoint.smAndUp"
                :label="$t('agent.tier.title')"
                class="mb-4" />
              <tier-data-table
                ref="TierDataTable"
                @selected="select($event)" />
            </template>
            <tier-product-data-table
              v-else
              ref="TierProductDataTable"
              :item-tier-id="selected.id"
              @close="deselect()" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        value="agent">
        <v-card flat>
          <v-card-text>
            <div class="flex sm:justify-between flex-col sm:flex-row sm:items-center mb-4">
              <title-label :label="$t('agent.agent.title')" />
              <v-spacer />
              <div class="flex-grow-1">
                <v-text-field
                  append-icon="mdi-magnify"
                  :placeholder="$t('app.form.search.placeholder')"
                  dense
                  hide-details
                  outlined
                  @input="search($event)" />
              </div>
            </div>
            <agent-data-table
              ref="ResellerDataTable"
              :q="resellerQuery" />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        value="setting">
        <option-form />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import AgentRemoveList from '@/views/Agent/components/Agent/AgentRemoveList.vue'
import AgentCreate from '@/views/Agent/components/Agent/AgentCreate.vue'
import AgentDataTable from '@/views/Agent/components/Agent/AgentDataTable.vue'
import TierDataTable from '@/views/Agent/components/Tier/TierDataTable.vue'
import TierCreate from '@/views/Agent/components/Tier/TierCreate.vue'
import TierProductDataTable from '@/views/Agent/components/Tier/TierProductDataTable.vue'
import OptionForm from '@/views/Agent/components/Option/OptionForm.vue'

export default {
  name: 'Agent',
  components: {
    AgentRemoveList,
    AgentCreate,
    AgentDataTable,
    TierCreate,
    TierDataTable,
    TierProductDataTable,
    OptionForm
  },
  data () {
    return {
      selected: null,
      resellerQuery: ''
    }
  },
  computed: {
    ...mapGetters({
      permission: 'Auth/permission'
    }),
    tabHeaders () {
      return [
        {
          id: '1',
          value: 'manage',
          title: 'จัดการตัวแทนจำหน่าย',
          show: this.permission.settingReseller
        },
        {
          id: '2',
          value: 'agent',
          title: 'ตัวแทนจำหน่าย',
          show: this.permission.settingReseller
        },
        {
          id: '3',
          value: 'setting',
          title: 'ตั้งค่าตัวแทนจำหน่าย',
          show: this.permission.settingReseller
        }
      ].filter((item) => item.show)
    },
    tab: {
      set (tab) {
        this.$router.push(`/agent/${tab}`)
      },
      get () {
        return this.$route.path.split('/')[2]
      }
    }
  },
  // mounted () {
  //   this.tab = this.$route.query.tab ? Number(this.$route.query.tab) : 0
  // },
  methods: {
    resellerRefetch () {
      this.$refs.ResellerDataTable.refetch()
    },
    tierRefetch () {
      this.$refs.TierDataTable.refetch()
    },
    tierProductDataTable () {
      this.$refs.TierProductDataTable.refetch()
    },
    select (item) {
      this.selected = item
    },
    deselect () {
      this.selected = null
    },
    // eslint-disable-next-line func-names
    search: _.debounce(function (value) {
      this.resellerQuery = value
    }, 800)
  }
}
</script>

<style>

</style>

<style scoped>

</style>
